import React from "react";
import { Box, IconButton, TextField } from "@mui/material";
import NavigateBefore from "@mui/icons-material/NavigateBefore";
import NavigateNext from "@mui/icons-material/NavigateNext";
import dayjs from "dayjs";

export default function TransfersToolbar({
  selectedDate,
  onPrevDay,
  onNextDay,
  onDateChange,
  airportFilter,
  onAirportFilterChange,
  nameFilter,
  onNameFilterChange,
}) {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" gap={2} mb={2}>
      <IconButton onClick={onPrevDay}>
        <NavigateBefore />
      </IconButton>

      <TextField
        type="date"
        size="small"
        value={selectedDate.format("YYYY-MM-DD")}
        onChange={(e) => {
          const newDate = dayjs(e.target.value);
          if (newDate.isValid()) onDateChange(newDate);
        }}
      />

      <IconButton onClick={onNextDay}>
        <NavigateNext />
      </IconButton>

      <TextField
        label="Filter by Airport"
        size="medium"
        variant="outlined"
        value={airportFilter}
        onChange={(e) => onAirportFilterChange(e.target.value)}
      />

      <TextField
        label="Filter by Name"
        size="medium"
        variant="outlined"
        value={nameFilter}
        onChange={(e) => onNameFilterChange(e.target.value)}
      />
    </Box>
  );
}
